export default __webpack_public_path__ + "726fa2fe64adedf1b936fe73c9d952a0.png";